import { render, staticRenderFns } from "./oferta-academica.vue?vue&type=template&id=3fd76f13&"
import script from "./oferta-academica.vue?vue&type=script&lang=js&"
export * from "./oferta-academica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports